import * as billzPricing from 'oems/billz/pricing';
import * as snaptaxPricing from 'oems/snaptax/pricing';

const oemPricing =
  process.env.REACT_APP_OEM_NAME === 'billz'
    ? billzPricing
    : process.env.REACT_APP_OEM_NAME === 'snaptax'
    ? snaptaxPricing
    : null;

if (!oemPricing) {
  throw new Error('Provide proper REACT_APP_OEM_NAME env');
}

export const pricing = oemPricing;
